import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  "data-slot": "icon",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#eee",
      d: "M167 16a256 256 0 0 1 178 0v480a256 256 0 0 1-178 0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0052b4",
      d: "M167 16v480a256 256 0 0 1 0-480"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#d80027",
      d: "M345 16a256 256 0 0 1 0 480z"
    }, null, -1)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "french"}) } }